'use strict';
import angular from 'angular';

angular.module('ratecard.directives', [])
    .directive('productSelect', productSelect)
    .directive('productFieldSelect', productFieldSelect);

productSelect.$inject = [];
function productSelect(){
    return {
        restrict: 'A',
        link: function(scope, el) {
            scope.productSelection = el;
            var products = [
                {id: 'rtbdisplay', text: 'RTB Display'},
                {id: 'productowner', text: 'Product Owner'},
                {id: 'searchmarketing', text: 'Search Marketing'},
                {id: 'emailmarketing', text: 'Email Marketing'}
            ]

            el.select2({
                data: products,
                multiple: false,
                placeholder: 'Select...',
                width: '100%',
                allowClear: true
            })
        }
    }
}

productFieldSelect.$inject = [];
function productFieldSelect(){
    return {
        restrict: 'A',
        link: function(scope, el) {
            scope.productSelection = el;
            var products = [
                {id: 'adsize', text: 'Ad_Size'},
                {id: 'adtype', text: 'Ad_Type'},
                {id: 'category', text: 'Category'},
                {id: 'floor', text: 'Floor'},
                {id: 'delivery_type', text: 'Delivery Type'},
                {id: 'discount', text: 'Discount'},
                {id: 'placement', text: 'Placement'},
                {id: 'exception', text: 'Exception'},
                {id: 'active', text: 'Active'}
            ]

            el.select2({
                data: products,
                multiple: true,
                placeholder: 'Select...',
                width: '100%',
                allowClear: true
            })
        }
    }
}